
import UnderConstruction from "./pages/UnderConstruction";

function App() {
  return (
    <>
      <UnderConstruction />
    </>
  );
}

export default App;
